<script>
  export let text;
  export let length;
  export let error;

  let show = false;
</script>

<strong
  class="comboboxstyle paragraphstyle firstitem {error ? 'error' : ''} {show
    ? ''
    : 'encrypted'}"
  ><img
    src="/images/view.svg"
    loading="lazy"
    width="30"
    height="30"
    alt=""
    on:click={() => {
      show = !show;
    }}
  /><input type="text" maxlength={length} bind:value={text} /></strong
>

<style>
  input {
    width: 100%;
    height: 100%;
    margin: 0px;
    background: transparent;
    padding: 0px;
    border: 0px;
    text-align: center;
  }

  strong {
    padding: 5px !important;
    position: relative;
    background-color: #ededed !important;
  }

  strong.error {
    border: 1px solid red;
  }

  strong.encrypted {
    font-family: asterisks;
  }

  img {
    position: absolute;
    top: 0px;
    right: 5px;
    width: 20px;
    cursor: pointer;
  }
</style>
